(() => {
  const selections = new Map();
  const observedProducts = new WeakSet();
  function refreshProductQuantity(product) {
    const context = product.querySelector('[data-qva-order-context]');
    const form = product.querySelector('.product-form__quantity');
    if (!context || !form) return;
    const label = form.querySelector('.quantity__label > span[aria-hidden="true"]');
    if (label && label.textContent !== context.dataset.qvaOrderLabel) label.textContent = context.dataset.qvaOrderLabel;
  }
  function initializeProducts(root=document) {
    const products=[...(root.matches?.('product-info')?[root]:[]),...root.querySelectorAll('product-info')];
    products.forEach(product=>{
      refreshProductQuantity(product);
      if(observedProducts.has(product))return;
      observedProducts.add(product);
      // Variant changes replace price and label fragments; do not alter native
      // quantity limits, variant selection, form submission or inventory logic.
      new MutationObserver(()=>refreshProductQuantity(product)).observe(product,{childList:true,subtree:true});
    });
  }
  document.addEventListener('product-info:loaded',event => initializeProducts(event.target));
  function updateSummary(section, count) {
    const summary = section.querySelector('[data-qva-filter-summary]');
    if (!summary) return;
    const flow = section.querySelector('[data-qva-flow]'), pipe = section.querySelector('[data-qva-pipe]');
    const container = summary.querySelector('[data-qva-custom-chips]');
    container.replaceChildren();
    [[flow,'flow'],[pipe,'pipe']].forEach(([select,key]) => {
      if (!select?.value) return;
      const text = select.selectedOptions[0].textContent;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'qva-filter-chip'; button.dataset.qvaRemoveCustom = key;
      button.setAttribute('aria-label',summary.dataset.qvaRemoveLabel.replace('[[filter]]',text));
      const label = document.createElement('span');label.textContent = text;
      const icon = document.createElement('span');icon.textContent = '×';icon.setAttribute('aria-hidden','true');
      button.append(label,icon);container.append(button);
    });
    const active = Boolean(summary.querySelector('[data-qva-native-filter]') || container.childElementCount);
    summary.querySelector('.qva-filter-summary__label').hidden = !active;
    summary.querySelector('[data-qva-clear-all]').hidden = !active;
    summary.querySelector('[data-qva-result-count]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'vi').format(count ?? Number(summary.dataset.qvaNativeCount));
  }
  function initializeFilters(root = document) {
    root.querySelectorAll('[data-qva-irrigation-grid]').forEach(section => {
      const controls = section.querySelector('.qva-irrigation-filters');
      if (!controls || controls.dataset.ready) return;
      controls.dataset.ready = 'true';
      const cards = Array.from(section.querySelectorAll('[data-qva-irrigation-product]'));
      const flow = controls.querySelector('[data-qva-flow]'), pipe = controls.querySelector('[data-qva-pipe]');
      const params = new URLSearchParams(location.search);
      const state = selections.get(location.pathname) || {flow:params.get('qva_flow') || '',pipe:params.get('qva_pipe') || ''};
      [[flow,'flow'],[pipe,'pipe']].forEach(([select,key]) => {
        const values = [...new Set(cards.map(card => (card.dataset[key] || '').trim()).filter(Boolean))];
        if(state[key] && !values.includes(state[key])) values.push(state[key]);
        values.sort((a,b)=>a.localeCompare(b,undefined,{numeric:true}));
        values.forEach(value=>select.add(new Option(key==='flow'?value+' L/h':value,value)));
        select.value=state[key];select.closest('label').hidden=values.length===0;
      });
      const update = () => {
        selections.set(location.pathname,{flow:flow.value,pipe:pipe.value});
        let count=0;
        cards.forEach(card=>{card.hidden=Boolean((flow.value && (card.dataset.flow||'').trim()!==flow.value)||(pipe.value && (card.dataset.pipe||'').trim()!==pipe.value));if(!card.hidden)count++;});
        updateSummary(section,count);
        const empty=section.querySelector('.qva-irrigation-no-results');if(empty)empty.hidden=count!==0;
      };
      controls.addEventListener('change',update);
      section.addEventListener('qva:filters-reset',update);
      controls.hidden=flow.options.length===1 && pipe.options.length===1;
      update();
    });
    root.querySelectorAll('[data-qva-filter-summary]').forEach(summary=>{
      if (!summary.closest('[data-qva-irrigation-grid]')?.querySelector('.qva-irrigation-filters')) updateSummary(summary.parentElement);
    });
  }
  document.addEventListener('click',event=>{
    const more=event.target.closest('.qva-filter-more');
    if(more){const list=more.previousElementSibling;if(!list?.matches('.qva-filter-list'))return;const expanded=list.classList.toggle('qva-expanded');more.setAttribute('aria-expanded',String(expanded));more.textContent=expanded?more.dataset.less:more.dataset.more;return;}
    const custom=event.target.closest('[data-qva-remove-custom]');
    if(custom){const section=custom.closest('[data-qva-irrigation-grid]');const select=section.querySelector(`[data-qva-${custom.dataset.qvaRemoveCustom}]`);select.value='';select.dispatchEvent(new Event('change',{bubbles:true}));select.focus();return;}
    const link=event.target.closest('[data-qva-native-filter],[data-qva-clear-all]');
    if(!link || event.button!==0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)return;
    const summary=link.closest('[data-qva-filter-summary]');
    if(link.matches('[data-qva-clear-all]')){
      selections.set(location.pathname,{flow:'',pipe:''});
      const section=summary.closest('[data-qva-irrigation-grid]');
      section?.querySelectorAll('[data-qva-flow],[data-qva-pipe]').forEach(select=>select.value='');
      if(!summary.querySelector('[data-qva-native-filter]')){event.preventDefault();section?.dispatchEvent(new Event('qva:filters-reset'));summary.querySelector('[data-qva-result-count]')?.closest('[role="status"]')?.setAttribute('tabindex','-1');summary.querySelector('[role="status"]')?.focus();return;}
    }
    if(typeof FacetFiltersForm !== 'undefined'){
      event.preventDefault();
      const url=new URL(link.href,location.origin);
      FacetFiltersForm.renderPage(url.searchParams.toString(),null);
    }
  });
  function initialize(root=document){initializeProducts(root);initializeFilters(root);}
  initialize();
  const grid=document.getElementById('ProductGridContainer');
  if(grid)new MutationObserver(()=>initialize(grid)).observe(grid,{childList:true});
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
